








import Component from "vue-class-component";
import {Emit, Prop, Ref, Vue} from "vue-property-decorator";
import {Api} from "shared/api";
import {apiHandler} from "@/services/api-handler";
import {AuthService} from "@/services/auth";
import {UploadFileResponse} from "shared/api/routes/file";

@Component({})
export default class FileUpload extends Vue {
    @Prop({default: "Upload New File"})
    label!: string;

    @Prop({default: ""})
    value!: string;

    @Prop({default: () => []})
    allowedExtensions!: string[];

    @Prop({default: true})
    showCurrent!: boolean;

    @Ref("file-input")
    fileInput!: HTMLInputElement;

    uploading = false;

    @Emit("input")
    @Emit("change")
    onInput(newFile: string) {
        return newFile;
    }

    async fileChanged() {
        if (this.fileInput.files?.length !== 1) {
            // eslint-disable-next-line no-console
            console.log("No file selected");
            return;
        }

        const extension = this.fileInput.files[0].name.split(".").pop();

        if (!extension) {
            alert("File has no extension");
            return;
        }

        if (this.allowedExtensions && this.allowedExtensions.length > 0) {
            if (this.allowedExtensions.map(m => m.toLowerCase()).indexOf(extension.toLowerCase()) === -1) {
                alert(`Allowed Extensions: ${this.allowedExtensions.join(", ")}`);
                return;
            }
        }

        const uploadUrl = process.env.API_ROOT + Api.file._fullPath;
        const body = new FormData();
        body.append("file", this.fileInput.files[0]);
        this.uploading = true;
        const rawResult = await apiHandler(() => fetch(uploadUrl, {
            method: "PUT",
            headers: {token: AuthService.getToken() ?? ""},
            body
        }).then(r => r.json() as Promise<UploadFileResponse>));
        this.uploading = false;
        this.onInput(rawResult.path);
    }
}

